var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"header"},[_c('img',{attrs:{"src":require("../assets/logo.png")}}),_c('div',{staticClass:"tabs"},[_vm._l((_vm.tabs),function(item,index){return [_c('div',{key:index,class:[_vm.active === item.id ? 'tab-active' : ''],on:{"click":function($event){return _vm.tabsChange(item)}}},[_vm._v(_vm._s(item.name))])]})],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }